'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedNumber = require('./FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _NumberTypes = require('../constants/NumberTypes');

var _NumberTypes2 = _interopRequireDefault(_NumberTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedCurrency',

  propTypes: {
    abbreviate: _react.PropTypes.bool,
    abbreviateThreshold: _react.PropTypes.number,
    currencyCode: _react.PropTypes.string,
    precision: _react.PropTypes.number,
    simplifyCurrency: _react.PropTypes.bool,
    stripInsignificantZeros: _react.PropTypes.bool,
    unit: _react.PropTypes.string,
    useCurrencyCode: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      stripInsignificantZeros: false,
      simplifyCurrency: false
    };
  },
  render: function render() {
    return _react2.default.createElement(_FormattedNumber2.default, _extends({ style: _NumberTypes2.default.CURRENCY }, this.props));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.433/js/components/FormattedCurrency.js
// module id = 232
// module chunks = 3 4 5